import { Flex } from '@chakra-ui/react';
import {
  faChartLine,
  faScrewdriverWrench,
} from '@fortawesome/free-solid-svg-icons';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import { ModalLayout } from '@ui/components/layout/ModalLayout';
import { Navigation } from '@ui/components/layout/Navigation';
import { WithPermission } from '@ui/components/Permission';
import { Router } from '@ui/config/routes';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export function HomeLayout() {
  return (
    <>
      <ModalLayout />

      <Flex direction="row">
        <Navigation.Menu>
          <Navigation.TeamSelector />

          <WithPermission minimumRole={Router.routes.admin.minimumRole}>
            <Navigation.Item
              label="Admin"
              path={Router.path(Router.routes.admin)}
              icon={faScrewdriverWrench}
            />
          </WithPermission>

          <Navigation.Item
            label="Metrics"
            path={Router.path(Router.routes.metrics)}
            icon={faChartLine}
          />

          <Navigation.ResourceHubLink />
        </Navigation.Menu>

        {/* @NOTE(shawk): ensure <NavigationBar /> stays visible
            while descendent lazy-loaded routes are loading */}
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Flex>
    </>
  );
}
